import { Box, chakra, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import useIsMobile from 'lib/hooks/useIsMobile';

interface Props {
  children: [React.JSX.Element, React.JSX.Element | null] | (React.JSX.Element | null);
  className?: string;
}

const ContractVerificationFormRow = ({ children, className }: Props) => {
  const isMobile = useIsMobile();
  const hintColor = useColorModeValue('#616161', '#747474');

  const firstChildren = Array.isArray(children) ? children[0] : children;
  const secondChildren = Array.isArray(children) ? children[1] : null;
  const showHint = !(isMobile && !secondChildren) && secondChildren != null;

  return (
    <Box className={ className } display="flex" flexDirection="column" alignItems="stretch" rowGap={ 2 }>
      <Box>{ firstChildren }</Box>
      { showHint ? (
        <Box
          color={ hintColor }
          fontSize="16px"
          fontWeight={ 500 }
          fontFamily="'Space Grotesk', sans-serif"
        >
          { secondChildren }
        </Box>
      ) : null }
    </Box>
  );
};

export default React.memo(chakra(ContractVerificationFormRow));
